module.exports = __webpack_public_path__ + "../resources/img/ic_wind_weather.a12540f3.svg";